
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare, faInstagram } from '@fortawesome/free-brands-svg-icons';
import '../Assets/css/footer.css';
import bannerGroup from '../Assets/img/barralogos.png';

export const Footer = () => {
    return (
        <footer className="footer" id="contacto">
            <h1>Contacto</h1>
            <div className="contact-info">
                <div className="contact-item">
                    <h4>Luis Silva</h4>
                    <p>Contacto Gerencial</p>
                    <p>+569 3910 4385</p>
                    <p className="email">gerencia@plussmineria.cl</p>
                </div>
                <div className="contact-item">
                    <h4>Brayan Cruz</h4>
                    <p>Contacto Comercial</p>
                    <p>+569 9594 3348</p>
                    <p className="email">a.comercial@plussmineria.cl</p>
                </div>
            </div>
            <div className="footer-logos">
                <img src={bannerGroup} alt="Plus Chile" />
            </div>
            <div className="social-icons">
                <a href="https://www.facebook.com/plussmineria" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faFacebookSquare} size="2x" color="white"/>
                </a>
                <a href="https://www.instagram.com/plussmineria/" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faInstagram} size="2x" color="white"/>
                </a>
            </div>
            <p className="footer-text">Todos los derechos reservados Plus Minería | Desarrollado por Grupo Plus Chile</p>
        </footer>
    );
}



